export type ErpAccountingCatalogOption = {
  uuid: string;
  name: string;
};

export type ErpAccountNumberConfiguration = {
  uuid: string;
  segmentCount: number;
  separator: string;
  /** Indica si la estructura se puede modificar desde ERP. */
  editable: boolean;
};

export type ErpAccountingAccountTreeNode = {
  uuid: string;
  source: ErpAccountingCatalogOption | null;
  editable: boolean;
  accountNumber: string;
  formattedAccountNumber: string;
  name: string;
  type: ErpAccountingCatalogOption;
  nature: ErpAccountingCatalogOption | null;
  children: ErpAccountingAccountTreeNode[];
};

export type ErpAccountingAccountParent = {
  uuid: string;
  source: ErpAccountingCatalogOption | null;
  accountNumber: string;
  formattedAccountNumber: string;
  name: string;
  type: ErpAccountingCatalogOption | null;
};

export type ErpAccountingAccountDto = {
  uuid: string;
  companyUuid: string | null;
  source: ErpAccountingCatalogOption | null;
  editable: boolean;
  accountNumber: string;
  formattedAccountNumber: string;
  name: string;
  type: ErpAccountingCatalogOption;
  nature: ErpAccountingCatalogOption | null;
  parent: ErpAccountingAccountParent | null;
  createdAt?: string;
  updatedAt?: string;
};

export type ErpAccountingAccountFormSelects = {
  types: ErpAccountingCatalogOption[];
  natures: ErpAccountingCatalogOption[];
};

/** Alta y edición de una cuenta Afectable. El tipo es implícito. */
export type ErpAccountingAccountRequest = {
  accountNumber: string;
  name: string;
  parentUuid: string;
  parentSourceUuid: string;
  natureUuid: string | null;
};

export const ERP_ACCOUNTING_ACCOUNT_NAME_MAX = 365;
